import register from '../../util/init';
import {flickity} from '../../util/flickity';

function servicesService (container) {
  // gallery init
  container.querySelectorAll('.gallery').forEach((el) => {
    if (el.childElementCount > 1) {
      const flkty = flickity(el, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false
      });
    }
  });
}
register('services-service', servicesService);



// WEBPACK FOOTER //
// ./assets/j/src/services/service.js